define.alias("shared/components/shared/ui/flash-message", "settings/components/shared/ui/flash-message");